<template>
    <div id="login-container">
        <div class="login-box">
            <h2>Serdar Kaynak Yönetim Sayfası</h2>
            <table>
                <tbody>
                    <tr>
                        <td>
                            <p>Kullanıcı Adı:</p> 
                        </td>
                        <td>
                            <input type="text" v-model="cred.username">
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Şifre: </p>
                        </td>
                        <td><input type="password" v-model="cred.password"></td>
                    </tr>
                    <tr><td><br></td></tr>
                    <tr>
                        <td><button @click="login">Giriş yap</button></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
export default{
    data(){
        return{
            isAuthenticated: false,

            cred:{
                username: "",
                password: "",
            }
        }
    },
    methods:{
        async login(){
            const response = await axios.post("/api-path/Auth/site-admin-login-page", this.cred);
            
            if(response.data === true){
                this.cred.username = "";
                this.cred.password = "";
                console.log("DEVAM");
                localStorage.setItem("confirmation", "onaylandi");
                this.$router.push('/site-settings/exhibition-edit');
                return;
            }

            if(response.data === false){
                this.cred.username = "";
                this.cred.password = "";
                alert("Kullanıcı adı veya Şifre yanlış!");
                return;
            }

        }
    },
    mounted(){
        if (localStorage.getItem("confirmation") === "onaylandi") {
            this.$router.push('/site-settings/exhibition-edit');
        } 
    }
}
</script>

<style scoped>
#login-container{
    width: 100vw;
    height: 100vh;
    background-color: rgb(27, 27, 27);
    display: flex;
    align-items: center;
    justify-content: center;
}

.login-box{
    border-radius: 1%;
    width: 500px;
    height: 400px;
    background-color: aliceblue;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
}

table{
    margin: auto;
}

button {
    height: 40px;
    border-radius: 5%;
    border: none;
    font-size: 15px;
    background-color: #218838;
    color: aliceblue;
    cursor: pointer;
}
</style>